import React from 'react';
import Button from '@components-clean/core/button';
import ConfirmationDialog from '@components-clean/core/confirmation-dialog';
import { useBoolean } from '@hooks/index';

const ConfirmationDialogPage = () => {
    const isDialogOpened = useBoolean(false);

    return (
        <>
            <Button onClick={isDialogOpened.toggle} data-testid="toggle-dialog-button" primary>
                Open Dialog
            </Button>
            {isDialogOpened.value && (
                <ConfirmationDialog
                    title="Dialog Title"
                    dataTestId="confirmation-dialog"
                    onClose={() => isDialogOpened.setFalse()}
                    onSubmit={() => isDialogOpened.setFalse()}
                >
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit
                </ConfirmationDialog>
            )}
        </>
    );
};

export default ConfirmationDialogPage;
